"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfOfferUnderPropertyMediaDto = instanceOfOfferUnderPropertyMediaDto;
exports.OfferUnderPropertyMediaDtoFromJSON = OfferUnderPropertyMediaDtoFromJSON;
exports.OfferUnderPropertyMediaDtoFromJSONTyped = OfferUnderPropertyMediaDtoFromJSONTyped;
exports.OfferUnderPropertyMediaDtoToJSON = OfferUnderPropertyMediaDtoToJSON;
exports.OfferUnderPropertyMediaDtoToJSONTyped = OfferUnderPropertyMediaDtoToJSONTyped;
/**
 * Check if a given object implements the OfferUnderPropertyMediaDto interface.
 */
function instanceOfOfferUnderPropertyMediaDto(value) {
    return true;
}
function OfferUnderPropertyMediaDtoFromJSON(json) {
    return OfferUnderPropertyMediaDtoFromJSONTyped(json, false);
}
function OfferUnderPropertyMediaDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'fileUrl': json['fileUrl'] == null ? undefined : json['fileUrl'],
    };
}
function OfferUnderPropertyMediaDtoToJSON(json) {
    return OfferUnderPropertyMediaDtoToJSONTyped(json, false);
}
function OfferUnderPropertyMediaDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'fileUrl': value['fileUrl'],
    };
}
